module.exports = __webpack_public_path__ + "img/unodc-logo-white.c882fb86.png";